import { generateNanoId } from '@amzn/journeys-common';
import { map } from 'es-toolkit/compat';
import type { FC } from 'react';
import { Badge } from 'react-bootstrap';
import { classes, stylesheet } from 'typestyle';
import type { PodBadge } from '../campaign.types';

export type CampaignBadgesProps = {
  badges: PodBadge[];
  className?: string;
  dataCY?: string;
};

const css = stylesheet({
  badge: {
    marginBottom: 5,
    marginRight: 5,
  },
  container: {
    maxWidth: 200,
  },
});

export const CampaignBadges: FC<CampaignBadgesProps> = ({ badges, className, dataCY }) => {
  if (!badges?.length) return null;
  return (
    <article className={classes('pod-status-badges', css.container, className)} data-cy={dataCY}>
      {map(badges, (badge, index) => (
        <Badge
          className={classes('pod-badge', css.badge)}
          data-cy={`${index}-${badge.variant}`}
          key={generateNanoId()}
          pill
          variant={badge.variant}
        >
          {badge.label}
        </Badge>
      ))}
    </article>
  );
};
